// extracted by mini-css-extract-plugin
export var label = "_go-2";
export var slideContainer = "_go-0";
export var slider = "_go-1";